import { ConsentSurface } from './ConsentSurface'
import { CookieConsentBanner } from './CookieConsent'

/**
 * `customer-consent` — what the customer permits before anything third-party loads.
 *
 * No routes: a banner, app-wide, as in legacy's `App.tsx`. It is its own module rather than shell code
 * because it carries real rules — which trackers a decision permits, and the fact that the decision is
 * read *before* any script tag is written, not after.
 */
export const customerConsentModule = {
  name: 'customer-consent',
  banners: [{ name: 'cookie-consent', component: ConsentSurface }],
} as const

export { ConsentSurface }
export { CookieConsentBanner }
export { useConsentedTrackers } from './trackers'
export {
  CONSENT_EVENT,
  CONSENT_KEY,
  UNDECIDED,
  buildConsent,
  consentFrom,
  permittedTrackers,
  readConsent,
  trackerSettingsOf,
  writeConsent,
  type CookieConsent,
  type Tracker,
  type TrackerSettings,
} from './consent'
